import { Weapon, type WeaponConfig } from './Weapon';

const LASER_CONFIG: WeaponConfig = {
  id: 'laser',
  name: 'Лазер',
  // economy W12, calibrated to budget=30+10L
  price: 6800,
  fireRateMs: 0,
  bulletsPerShot: 0,
  spreadDeg: 0,
  soundKey: 'pistol_shot',
  soundVolume: 0.4,
  shakeShoot: null,
  fireMode: 'beam',
  beamWidth: 5,
  rangePx: 1280,
  maxEnergy: 100,
  energyDrainPerSec: 23,
  energyRegenPerSec: 5,
  minEnergyToFire: 10,
  damagePerSecond: 15,
};

export function createLaser(): Weapon {
  return new Weapon(LASER_CONFIG);
}
